import TourActions from "./constants";
import { IActionObject } from "./types";

export function initializeTourWithParams(tour: object): IActionObject {
  return { type: TourActions.SET_TOUR_PARAMS, data: { tour } };
}

export default {
  initializeTourWithParams,
};
